export default "https://cdn-static.gokick.com/assets/1d764bbda6f1db3d5ed96a1ece7edd078534d524/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";